export const TEST_ID = 'badges';
